/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
  Skeleton,
  Table,
  AutoComplete,
  Input,
  Space,
  Button,
  Modal,
  Tooltip,
  Drawer,
  Select,
  Typography,
  Radio,
  Checkbox,
  Dropdown,
} from "antd";
import "../index.css";
import {
  CloseOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
  SettingOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import api from "../../../helpers";
import toast from "react-hot-toast";
import { FaRegEdit } from "react-icons/fa";
import {
  loadUserRoleList,
  loadUserAccessList,
  loadMenuList,
} from "../../../store/purchase-orders/actions";
import SimpleReactValidator from "simple-react-validator";

const UserRoleDetails = (props) => {
  const dispatch = useDispatch();
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const media = useMedia();

  // initial state
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [userRoleId, setUserRoleId] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [permissionOpen, setPermissionOpen] = useState(false);
  const [isAccessModalOpen, setIsAccessModalOpen] = useState(false);
  const [menuAccess, setMenuAccess] = useState([]);
  const [accessValue, setAccessValue] = useState("");
  const [menuAccessData, setMenuAccessData] = useState([]);

  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 400);
    dispatch(loadUserRoleList());
    dispatch(loadMenuList());
    dispatch(loadUserAccessList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { user_role_list, menu_list, userAccess_list } = useSelector(
    (state) => state.PurchaseOrders
  );

  const HeaderData = [
    {
      key: "roleName",
      title: <p className="font-label text-[13px] font-semibold">Role Name</p>,
      dataIndex: "roleName",
      width: "30%",
      sorter: (a, b) => a.roleName.length - b.roleName.length,
    },
    {
      key: "roleDescription",
      title: (
        <p className="font-label text-[13px] font-semibold">Role Description</p>
      ),
      dataIndex: "roleDescription",
      width: "20%",
    },
    {
      key: "Rolemode",
      title: <p className="font-label text-[13px] font-semibold">Mode</p>,
      dataIndex: "roleMode",
      width: "20%",
    },
    {
      key: "rolePermission",
      title: (
        <p className="font-label text-[13px] font-semibold whitespace-nowrap">
          Role Permission
        </p>
      ),
      dataIndex: "rolePermission",
      width: "10%",
    },
    {
      key: "status",
      title: <p className="font-label text-[13px] font-semibold">Status</p>,
      dataIndex: "status",
      width: "15%",
    },
    {
      key: "action",
      title: <p className="font-label text-[13px] font-semibold">Action</p>,
      dataIndex: "action",
      width: "15%",
    },
  ];

  const menuOptions =
    menu_list && menu_list.length > 0
      ? menu_list.flatMap((menu) => {
          if (menu.subMenus && menu.subMenus.length > 0) {
            return menu.subMenus.map((sub) => ({
              label: `${menu.menuName} → ${sub.menuName}`,
              value: sub._id,
            }));
          }
          return {
            label: menu.menuName,
            value: menu._id,
          };
        })
      : [];

  // form states
  const [userRoleName, setUserRoleName] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [description, setDescription] = useState("");
  const [roleMode, setRoleMode] = useState("");

  const onClose = () => {
    setOpen(false);
    setUserRoleName("");
    setDescription("");
    setRoleMode("");
  };

  const [userRoleRows, setUserRoleRows] = useState([
    {
      _id: "",
      roleName: "",
      code: "",
      mode: "",
      descriptions: "",
      isDefault: "",
      status: "",
      action: "",
    },
  ]);

  const onPermissionClose = () => {
    setPermissionOpen(false);
    setIsAccessModalOpen(false);
  };

  const userRoleDataTable =
    !isEmpty(user_role_list) && user_role_list.length > 0
      ? user_role_list.map((data) => {
          return {
            _id: data._id,
            roleName: data.roleName,
            roleDescription: data.description || "--",
            roleMode: data.mode || "--",
            rolePermission: (
              <div
                className="flex text-[18px] cursor-pointer items-center justify-center"
                onClick={() => {
                  api
                    .post("/masters/getmenuaccess", { roleId: data._id })
                    .then((res) => {
                      const response = res.data;
                      // validate
                      const hasValidMenuIds =
                        Array.isArray(response) &&
                        response.every((item) => item.menuId);
                      if (!hasValidMenuIds) {
                        toast.error(
                          "Some menu access records are missing menuId. Please contact administrator."
                        );
                        return;
                      }
                      setMenuAccessData(response);
                      setPermissionOpen(true);
                      setUserRoleId(data._id);
                      setRoleData({ roleName: data.roleName, roleId: data._id });
                      const role = userAccess_list && userAccess_list.find(
                        (fil) => fil.roleId === data._id
                      );
                      dispatch(loadMenuList());
                      dispatch(loadUserAccessList());
                      setRoleAccess(role?.accesses || []);
                    })
                    .catch((error) => {
                      const errorMsg =
                        (error &&
                          error.response &&
                          error.response.data &&
                          error.response.data.message) ||
                        (error &&
                          error.response &&
                          error.response.data &&
                          error.response.data.error) ||
                        error.message;
                      toast.error(errorMsg || "Failed to load menu access");
                    });
                }}
              >
                <SettingOutlined />
              </div>
            ),
            action: (
              <div className="flex">
                <Tooltip title={"Edit"} placement="top" className="mr-2">
                  <div
                    className={
                      "cursor-pointer rounded-sm bg-[#08a35ae0] px-[8px] py-[6px] hover:bg-[#0b9b57e0] focus:bg-[#0b9b57e0] text-[white] font-label font-semibold text-start"
                    }
                    onClick={() => {
                      setUserRoleId(data._id);
                      setUserRoleName(data.roleName);
                      setDescription(data.description);
                      setRoleMode(data.mode);
                      setEditModal(true);
                      setOpen(true);
                    }}
                  >
                    <FaRegEdit className="text-[14px]" />
                  </div>
                </Tooltip>
                <Tooltip title={"Delete"} placement="top">
                  <div
                    className={
                      "cursor-pointer rounded-sm bg-[#e74c3c] px-[8px] py-[6px] hover:bg-[#bb1d0d] focus:bg-[#bb1d0d] text-[white] font-label font-semibold text-start"
                    }
                    onClick={() => {
                      setUserRoleId(data._id);
                      setConfirmationModal(true);
                    }}
                  >
                    <DeleteOutlined className="text-[14px]" />
                  </div>
                </Tooltip>
              </div>
            ),
            status: (
              <div
                className={
                  data &&
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusCode !== undefined &&
                  data.status[0].statusCode === 1
                    ? "w-[60%] flex justify-center cursor-pointer bg-[#08a35ae0] pt-1 pb-1 pr-2 pl-2 rounded-sm hover:bg-[#0b9b57e0] focus:bg-[#0b9b57e0] text-[white] font-label text-start"
                    : "w-[60%] flex justify-center cursor-pointer bg-[#e74c3c] pt-1 pb-1 pr-2 pl-2 rounded-sm hover:bg-[#bb1d0d] focus:bg-[#bb1d0d] text-[white] font-label text-start"
                }
              >
                {data &&
                data.status &&
                data.status.length > 0 &&
                data.status[0].statusCode !== undefined &&
                data.status[0].statusCode === 1
                  ? "Active"
                  : "Inactive"}
              </div>
            ),
          };
        })
      : [];

  useEffect(() => {
    if (userRoleDataTable && userRoleDataTable.length > 0) {
      setUserRoleRows(userRoleDataTable);
    } else {
      setUserRoleRows([]);
    }
  }, [user_role_list, userAccess_list, menu_list]);

  // search
  const [search, setSearch] = useState("");
  const handleSearch = (event) => {
    const filteredRows = userRoleDataTable.filter((row) =>
      Object.values(row).some((data) =>
        String(data).toLowerCase().includes(event.target.value.toLowerCase())
      )
    );
    setSearch(event.target.value);
    setUserRoleRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => setTableLoading(false), 200);
  };

  const resetForm = () => {
    setUserRoleName("");
    setDescription("");
    setRoleMode("");
  };

  const createUserRole = () => {
    if (simpleValidator.current.allValid()) {
      const userAccountList = {
        roleName: userRoleName,
        description,
        mode: roleMode,
      };
      api
        .post("/masters/addrole", userAccountList)
        .then((res) => {
          toast.success("User role created successfully");
          dispatch(loadUserRoleList());
          resetForm();
          setOpen(false);
          setEditModal(false);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(errorMsg || "There is an issue while creating the access");
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const updateUserRole = () => {
    if (simpleValidator.current.allValid()) {
      const userAccountList = {
        roleId: userRoleId,
        roleName: userRoleName,
        description,
        mode: roleMode,
      };
      api
        .post("/masters/updaterole", userAccountList)
        .then((res) => {
          toast.success("User role updated successfully");
          dispatch(loadUserRoleList());
          setOpen(false);
          setEditModal(false);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(errorMsg || "There is an issue while updating the role");
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const [roleAccess, setRoleAccess] = useState([]);
  const [roleData, setRoleData] = useState({ roleName: "", roleId: "" });

  // handle access changes (C R E D and extra ops)
  const handleAccessChange = (menuName, field, value) => {
    setRoleAccess((prev) => {
      const exists = prev.find((acc) => acc.menuName === menuName);
      if (exists) {
        return prev.map((acc) =>
          acc.menuName === menuName ? { ...acc, [field]: value } : acc
        );
      }
      return [
        ...prev,
        {
          menuName,
          create: false,
          read: false,
          update: false,
          delete: false,
          [field]: value,
        },
      ];
    });
  };

  // fallback columns (used only if no menuAccessData)
  const columns = [
    {
      key: "menuName",
      title: <p className="font-label text-[13px] font-semibold">Object Name</p>,
      dataIndex: "menuName",
      width: "20%",
    },
    ...["create", "read", "update", "delete"].map((op) => ({
      key: op,
      title: (
        <p className="font-label text-[13px] font-semibold">
          {op.charAt(0).toUpperCase() + op.slice(1)}
        </p>
      ),
      align: "center",
      render: (text, record) => (
        <Checkbox
          checked={record[op] || false}
          onChange={(e) => handleAccessChange(record.menuName, op, e.target.checked)}
        />
      ),
    })),
  ];

  // Dynamic columns: C R E D + Actions dropdown (checkboxes)
const dynamicColumns = React.useMemo(() => {
  if (!menuAccessData || menuAccessData.length === 0) return columns;

  const credCols = ["create", "read", "update", "delete"].map((op) => ({
    key: op,
    title: (
      <p className="font-label text-[13px] font-semibold">
        {op.charAt(0).toUpperCase() + op.slice(1)}
      </p>
    ),
    align: "center",
    render: (text, record) => {
      const menuAccessItem = menuAccessData.find((m) => m.menuId === record.menuId);
      // If no access data for this menu/submenu, show "--"
      if (!menuAccessItem) return <span>--</span>;
      const currentAccess = roleAccess.find((acc) => acc.menuName === record.menuName) || {};
      return <Checkbox checked={!!currentAccess[op]} onChange={(e) => handleAccessChange(record.menuName, op, e.target.checked)} />;
    },
  }));

  const actionsCol = {
    key: "actions",
    title: <p className="font-label text-[13px] font-semibold">Actions</p>,
    align: "left",
    width: "35%",
    render: (text, record) => {
      const menuAccessItem = menuAccessData.find((m) => m.menuId === record.menuId);
      const extraOps = menuAccessItem?.accesses?.[0] || {};
      const extraKeys = Object.keys(extraOps).filter((k) => !["create", "read", "update", "delete", "menuId"].includes(k));
      if (!menuAccessItem || extraKeys.length === 0) return <span>--</span>;

      const overlayContent = (
        <div style={{ padding: 8, maxWidth: 260, boxShadow: "0 2px 8px rgba(0,0,0,0.15)", background: "#fff", borderRadius: 4 }}
          onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
          {extraKeys.map((key) => {
            const currentAccess = roleAccess.find((acc) => acc.menuName === record.menuName) || {};
            return (
              <div key={key} className="flex items-center gap-2" style={{ padding: "6px 4px" }}>
                <Checkbox
                  checked={!!currentAccess[key]}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => handleAccessChange(record.menuName, key, e.target.checked)}
                />
                <span style={{ fontSize: 13, textTransform: "capitalize" }}>{key}</span>
              </div>
            );
          })}
        </div>
      );

      return (
        <Dropdown overlay={overlayContent} trigger={["click"]} placement="bottomLeft">
          <Button onClick={(e) => e.stopPropagation()} size="small" icon={<DownOutlined />}>Actions</Button>
        </Dropdown>
      );
    },
  };

  return [
    { key: "menuName", title: <p className="font-label text-[13px] font-semibold">Menu Name</p>, dataIndex: "menuName", width: "25%" },
    ...credCols,
    actionsCol,
  ];
}, [menuAccessData, roleAccess]);
 // re-run when menuAccessData or roleAccess changes

const tableData = React.useMemo(() => {
  if (!menu_list || menu_list.length === 0) return [];

  const validMenuIds = new Set(menuAccessData.map((item) => item.menuId)); // only menus/submenus returned from getmenuaccess

  return menu_list.map((menu) => {
    const topAccess = roleAccess.find((a) => a.menuName === menu.menuName) || {};
    const menuAccessItem = menuAccessData.find((item) => item.menuId === menu._id);
    const extraOperations = menuAccessItem?.accesses?.[0] || {};

    // validate submenus
    const children = (menu.subMenus || [])
      .filter((sub) => validMenuIds.has(sub._id)) // only include submenus that exist in getmenuaccess
      .map((sub) => {
        const subAccess = roleAccess.find((a) => a.menuName === sub.menuName) || {};
        const subMenuAccessItem = menuAccessData.find((item) => item.menuId === sub._id);
        const subExtraOperations = subMenuAccessItem?.accesses?.[0] || {};

        return {
          key: sub._id,
          menuId: sub._id,
          menuName: sub.menuName,
          create: !!subAccess.create,
          read: !!subAccess.read,
          update: !!subAccess.update,
          delete: !!subAccess.delete,
          extraOperations: subExtraOperations,
        };
      });

    return {
      key: menu._id,
      menuId: menu._id,
      menuName: menu.menuName,
      create: !!topAccess.create,
      read: !!topAccess.read,
      update: !!topAccess.update,
      delete: !!topAccess.delete,
      extraOperations,
      children: children.length > 0 ? children : undefined,
    };
  });
}, [menu_list, roleAccess, menuAccessData]);



  // Save handler — builds payload using checked fields only
  const handleSave = () => {
    const accessedMenuIds = new Set(menuAccessData.map((m) => m.menuId));

    const accesses = (menu_list || [])
      .filter((menu) => accessedMenuIds.has(menu._id))
      .flatMap((menu) => {
        const parent = roleAccess.find((a) => a.menuName === menu.menuName) || {};
        const parentEntry = { menuId: menu._id, menuName: menu.menuName };

        if (parent.create) parentEntry.create = true;
        if (parent.read) parentEntry.read = true;
        if (parent.update) parentEntry.update = true;
        if (parent.delete) parentEntry.delete = true;

        // include extra ops flagged true
        const menuAccessItem = menuAccessData.find((m) => m.menuId === menu._id);
        if (menuAccessItem?.accesses?.[0]) {
          Object.keys(menuAccessItem.accesses[0]).forEach((k) => {
            if (k !== "menuId" && parent[k]) parentEntry[k] = true;
          });
        }

        const childEntries = (menu.subMenus || [])
          .filter((sub) => accessedMenuIds.has(sub._id))
          .map((sub) => {
            const subAcc = roleAccess.find((a) => a.menuName === sub.menuName) || {};
            const childEntry = { menuId: sub._id, menuName: sub.menuName };
            if (subAcc.create) childEntry.create = true;
            if (subAcc.read) childEntry.read = true;
            if (subAcc.update) childEntry.update = true;
            if (subAcc.delete) childEntry.delete = true;

            const subMenuAccessItem = menuAccessData.find((m) => m.menuId === sub._id);
            if (subMenuAccessItem?.accesses?.[0]) {
              Object.keys(subMenuAccessItem.accesses[0]).forEach((k) => {
                if (k !== "menuId" && subAcc[k]) childEntry[k] = true;
              });
            }
            return childEntry;
          });

        return [parentEntry, ...childEntries];
      });

    const payload = {
      roleName: roleData.roleName,
      roleId: roleData.roleId,
      accesses,
    };

    const roleAccessData = userAccess_list.find((it) => it.roleId === roleData.roleId);
    const accessExists = roleAccessData && Array.isArray(roleAccessData.accesses) && roleAccessData.accesses.length > 0;
    const apiUrl = accessExists ? "/masters/updateuseraccess" : "/masters/createuseraccess";

    api.post(apiUrl, payload)
      .then(() => {
        toast.success(apiUrl.includes("create") ? "User access created successfully" : "User access updated successfully");
        dispatch(loadUserAccessList());
        dispatch(loadUserRoleList());
        dispatch(loadMenuList());
        onPermissionClose();
      })
      .catch((err) => toast.error(err?.response?.data?.message || "Something went wrong"));
  };

  // window size hook (unchanged)
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
  }
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>User Role | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins border border-b-1 border-x-0 border-t-0 pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <h1 style={{ fontFamily: "Poppins" }} className="text-[16px] font-semibold">
                User Role
              </h1>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="w-[100%] mt-2">
        <Col md={24} lg={24} sm={24} xs={24} className={
            windowDimensions.height > 700 &&
            windowDimensions.height < 830 &&
            userRoleDataTable.length > 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 &&
                windowDimensions.height < 1000 &&
                userRoleDataTable.length > 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 700 &&
                windowDimensions.height < 830 &&
                userRoleDataTable.length == 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 &&
                windowDimensions.height < 1000 &&
                userRoleDataTable.length == 0
              ? "mt-[1px] h-[62vh] bg-[#ffffff] rounded-md"
              : windowDimensions.height >= 1000 && userRoleDataTable.length == 0
              ? "mt-[1px] h-[73vh] bg-[#ffffff] rounded-md"
              : windowDimensions.height >= 1000
              ? "mt-[1px] h-[82%] bg-[#ffffff] rounded-md"
              : "bg-[#ffffff] h-[72vh]um rounded-md"
          }>
          <Row className="flex flex-col">
            <Col md={24} lg={24} sm={24} xs={24} className="mt-5 mb-3">
              <Row className="flex justify-between">
                <Col md={10} lg={10} sm={24} xs={24} className="pr-3 lg:pr-0 md:pr-0 pl-4">
                  {loading ? (
                    <Skeleton.Input style={{ minWidth: media === "xxl" ? "185%" : media == "sm" || media == "xs" ? "255%" : "125%", height: "35px" }} />
                  ) : (
                    <div className={media === "sm" || media === "xs" ? "w-[59%]" : "w-[100%] lg:w-[65%] md:w-[65%]"}>
                      <AutoComplete style={{ marginRight: "10px", fontSize: "11px" }} className="w-[100%]">
                        <Input.Search size="middle" placeholder="Search role" style={{ fontFamily: "Poppins", fontSize: "11px" }} className="rounded-sm" name="search" value={search} onChange={(e) => handleSearch(e)} />
                      </AutoComplete>
                    </div>
                  )}
                </Col>

                <Col md={14} lg={14} sm={24} xs={24} className="pr-5">
                  <Row className="flex justify-end">
                    <Col md={7} lg={7} sm={24} xs={24} className="mt-1 lg:mt-0 md:mt-0">
                      {loading ? (
                        <Skeleton.Input style={{ minWidth: media === "xxl" ? "185%" : media == "sm" || media == "xs" ? "245%" : "125%", paddingRight: media == "md" ? "20px" : "20px", height: "35px", marginLeft: media == "sm" || media == "xs" ? "10px" : "" }} />
                      ) : (
                        <Row>
                          <Col md={24} lg={24} sm={14} xs={14} className="sm:pr-0 pr-3 ml-3 mt-1 lg:mt-0 xl:mt-0 xxl:mt-0 md:mt-0 xl:ml-0 xxl:ml-0 lg:ml-0 md:ml-0">
                            <div onClick={() => { setOpen(true); setEditModal(false); resetForm(); }} className="sm:flex sm:justify-center bg-[#074179] text-[white] focus:bg-[#1d3b59] cursor-pointer px-4 lg:px-7 xl:px-7 xxl:px-5 md:px-2 py-[6px] flex rounded-md hover:bg-[#1d3b59]">
                              <PlusOutlined className="mr-1" />
                              <h1 style={{ fontFamily: "Poppins" }} className="text-[14px] text-[white]">User Role</h1>
                            </div>
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            {/* Create / Update drawer */}
            <Drawer
              closable={false}
              title={<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h1 style={{ fontWeight: 600, fontFamily: "Poppins" }}>{editModal ? "Update User Role" : "Add User Role"}</h1>
                <Button type="text" onClick={onClose} className="font-label" icon={<CloseOutlined />} />
              </div>}
              placement="right" onClose={onClose} open={open} width={"400px"} maskClosable={false}
              footer={<div style={{ textAlign: "right", padding: "4px" }}>
                <Space>
                  <Button onClick={onClose} style={{ background: "#fff1f0", color: "#ff4d4f", borderColor: "#ffa39e" }} className="font-label">Cancel</Button>
                  <Button className="font-label" type="primary" onClick={editModal ? updateUserRole : createUserRole}>{editModal ? "Update" : "Submit"}</Button>
                </Space>
              </div>}>
              <Row>
                <Col md={24}><Typography className="font-label text-[13px] mb-2">User Role Name <span style={{ color: "red" }}>*</span></Typography>
                  <Input placeholder="Enter User Role Name" value={userRoleName} className="font-label mb-2 h-[40px]" onChange={(e) => setUserRoleName(e.target.value)} />
                </Col>
                <Col md={24}><Typography className="font-label text-[13px] mb-2">Description</Typography>
                  <Input.TextArea placeholder="Enter Description" value={description} className="font-label mb-2" onChange={(e) => setDescription(e.target.value)} rows={4} />
                </Col>
                <Col md={24}><Typography className="font-label text-[13px] mb-2 w-full">Mode</Typography>
                  <Radio.Group onChange={(e) => setRoleMode(e.target.value)} value={roleMode}>
                    <Radio value="Primary role">Primary role</Radio>
                    <Radio value="Secondary role">Secondary role</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            </Drawer>

            <Col span={24} className={media === "xxl" ? "pt-2 pl-4 pb-4" : "pr-1 pl-4 pb-4"}>
              <Table
                style={{ overflow: "hidden" }}
                bordered
                columns={HeaderData}
                dataSource={userRoleRows && userRoleRows.length > 0 && !isEmpty(userRoleRows[0]._id) ? userRoleRows : []}
                rowClassName={"table-row-label p-0"}
                expandable={{ defaultExpandAllRows: false }}
                pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ["5", "10", "20", "30"] }}
                sortDirections={"ascend"}
                loading={tableLoading ? true : false}
                scroll={{ x: 825 }}
              />
            </Col>
          </Row>
        </Col>

        <Modal
          open={confirmationModal}
          onOk={() => {
            api.post("/masters/deleterole", { roleId: userRoleId })
              .then((res) => { toast.success("User role deleted successfully"); dispatch(loadUserRoleList()); return res.data; })
              .catch((error) => {
                const errorMsg = (error && error.response && error.response.data && error.response.data.message) || (error && error.response && error.response.data && error.response.data.error) || (error && error.message);
                toast.error(errorMsg || "There is an issue while login");
                Promise.reject(error);
              });
            setConfirmationModal(false);
          }}
          closeIcon maskClosable={false} okText={"Delete"} cancelText={"Cancel"} okType="danger" onCancel={() => setConfirmationModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <CancelBtn />
              <div className="ml-3"><OkBtn /></div>
            </div>
          )}>
          <div className="text-center w-[100%] p-7">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="font-label text-center text-[16px] font-bold">Are you sure you want to Delete the User role?</h1>
          </div>
        </Modal>

        {/* Permission Drawer (table with permissions) */}
        <Drawer
          closable={false}
          title={<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h1 style={{ fontWeight: 600, fontFamily: "Poppins" }}>Add User Permission</h1>
            <div className="mr-[30px]">
              <Button type="text" onClick={onPermissionClose} className="font-label" icon={<CloseOutlined />} />
            </div>
          </div>}
          placement="right"
          open={permissionOpen}
          width={"100%"}
          maskClosable={false}
          footer={<div style={{ textAlign: "right", padding: "4px" }}>
            <Space>
              <Button onClick={onPermissionClose} style={{ background: "#fff1f0", color: "#ff4d4f", borderColor: "#ffa39e" }} className="font-label">Cancel</Button>
              <Button className="font-label" type="primary" onClick={() => handleSave()}>Save</Button>
            </Space>
          </div>}
        >
          <Row>
            <Col span={24}>
              <Table
                dataSource={tableData}
                columns={dynamicColumns}
                pagination={false}
              />
            </Col>
          </Row>
        </Drawer>

        <Modal title="Add User Access" open={isAccessModalOpen} maskClosable={false}
          onCancel={() => { setIsAccessModalOpen(false); setMenuAccess(""); setAccessValue(""); }} footer={null}>
          <Row>
            <Col md={24}>
              <Typography className="font-label mb-1 text-[13px]">Menu Type</Typography>
              <Select placeholder="Select Menu" options={menuOptions} value={menuAccess} onChange={(values) => setMenuAccess(values)} showSearch optionFilterProp="label" className="w-full" allowClear />
            </Col>
            <Col md={24}>
              <Typography className="font-label text-[13px] mb-2">Access</Typography>
              <Input placeholder="Enter Access" value={accessValue} onChange={(e) => setAccessValue(e.target.value)} className="m-2" />
            </Col>
            <div className="mt-[20px] flex text-end">
              <Button type="primary" onClick={() => { setIsAccessModalOpen(false); setMenuAccess(""); setAccessValue(""); }}>Save</Button>
            </div>
          </Row>
        </Modal>
      </Row>
    </React.Fragment>
  );
};

UserRoleDetails.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default UserRoleDetails;
